var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{attrs:{"inline":""}},[_c('b-form-group',{staticClass:"mr-2"},[(_vm.showCompanyFilter)?_c('field',{staticClass:"mr-2 mb-0",attrs:{"model":_vm.filters,"field":{
        ajax: true,
        attribute: 'company_id',
        component: 'app-relation-field',
        placeholder: _vm.$t('company.select_company'),
        source: {
          url: 'companies',
          params: {
            context: 'options',
          },
        },
      },"layout":"inline","label":_vm.$t('drivers.company')}}):_vm._e()],1),_c('field',{attrs:{"model":_vm.filters,"field":{
      attribute: 'date',
      component: 'date-range-field',
      options: {
        autoClose: true,
        formatted: 'll',
        onlyDate: true,
        outputFormat: 'YYYY-MM-DD',
        noShortcuts: true,
        maxDate: _vm.maxDate,
        minDate: _vm.minDate,
      },
    },"layout":"inline"}}),_c('field',{staticClass:"mr-2",attrs:{"model":_vm.filters,"field":{
      attribute: 'show_unassigned',
      component: 'checkbox-field',
      label: _vm.$t('drivers.new_layout_assignment_unassigned'),
    },"layout":"inline"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }